import React, { Fragment } from 'react';
import { css } from '@emotion/react';
import { RESPONSIVE_CLASSES } from '@zola/zola-ui/src/styles/emotion/mixins/responsive';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';
import ContentTiles from '@zola/zola-ui/src/components/PreAuthV3/ContentTiles';
import { CategoryScroller } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';

import { tilesContent } from './content';
import PartnerTile from './PartnerTile';

const mobileStyling = css`
  padding: ${SPACING.S32} ${SPACING.S24};

  ${RESPONSIVE_CLASSES.mobileOnly}
`;

const nonMobileStyling = css`
  border-bottom: none;

  ${RESPONSIVE_CLASSES.excludeMobile}
`;

const PartnerSection: React.FC = (): JSX.Element => {
  const titleComponent = (
    <Fragment>
      Partner with <span>Zola</span>
    </Fragment>
  );
  const tiles = tilesContent.map((tileProps, index) => (
    <PartnerTile key={`tile-${index}`} {...tileProps} />
  ));

  return (
    <Fragment>
      <div css={mobileStyling}>
        <HighlightTitle isH1={false}>{titleComponent}</HighlightTitle>
        <CategoryScroller>{tiles}</CategoryScroller>
      </div>
      <ContentTiles css={nonMobileStyling} title={titleComponent}>
        {tiles}
      </ContentTiles>
    </Fragment>
  );
};

export default PartnerSection;
